import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import AppLogo from "@/components/AppLogo";

const COMPANY = {
  razon_social: "A.E.I. Marketing y Negocios Tecnológicos, S.L.",
  cif: "B72939903",
  direccion: "C/ María Fernández \"La Perrata\", 12, 41740 Lebrija (Sevilla)",
  email: "abraham.herrera@tpvplus.es",
  telefono: "602 217 976",
};

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <div className="max-w-3xl mx-auto px-4 py-10">
        <div className="flex items-center justify-between mb-8">
          <Link
            to="/login"
            data-testid="back-to-login-link"
            className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-slate-600 hover:text-[#2563EB] transition"
          >
            <ArrowLeft size={16} weight="bold" /> Volver
          </Link>
          <AppLogo size={56} rounded={false} />
        </div>

        <article
          data-testid="privacidad-content"
          className="bg-white border border-slate-200 rounded-xl shadow-lg p-8 sm:p-10 space-y-6 text-slate-700 leading-relaxed"
        >
          <header>
            <h1 className="font-display font-bold text-3xl sm:text-4xl uppercase tracking-tighter text-slate-900">
              Política de Privacidad
            </h1>
            <p className="text-xs tracking-[0.25em] uppercase font-bold text-slate-400 mt-1">
              Reglamento (UE) 2016/679 (RGPD) y LOPDGDD 3/2018
            </p>
          </header>

          <Section title="1. Responsable del tratamiento">
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Titular:</strong> {COMPANY.razon_social}</li>
              <li><strong>CIF:</strong> {COMPANY.cif}</li>
              <li><strong>Dirección:</strong> {COMPANY.direccion}</li>
              <li><strong>Contacto en materia de protección de datos:</strong> <a className="text-[#2563EB] hover:underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
              <li><strong>Teléfono:</strong> {COMPANY.telefono}</li>
            </ul>
          </Section>

          <Section title="2. Finalidad del tratamiento">
            <p>
              Los datos personales facilitados a través de la plataforma <em>Entradasdeportivas</em> son tratados
              con las siguientes finalidades:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Gestión de socios, cuotas, acreditaciones y control de accesos del club.</li>
              <li>Emisión de carnés digitales y recibos.</li>
              <li>Cumplimiento de obligaciones legales, fiscales y contables.</li>
              <li>Comunicaciones estrictamente relacionadas con el servicio.</li>
            </ul>
          </Section>

          <Section title="3. Base legítima">
            <p>
              El tratamiento se basa en la ejecución de la relación contractual con el club,
              el consentimiento del interesado y el cumplimiento de obligaciones legales aplicables.
            </p>
          </Section>

          <Section title="4. Categorías de datos">
            <p>
              Datos identificativos (nombre, apellidos, DNI, fecha de nacimiento), datos de contacto
              (dirección postal, correo, teléfono), datos económicos (cuotas, pagos) e imagen
              (foto del carné) cuando el socio la facilita.
            </p>
          </Section>

          <Section title="5. Conservación">
            <p>
              Los datos se conservarán mientras se mantenga la relación con el club y, tras su finalización,
              durante los plazos legales exigidos (fiscales, contables y de prescripción de acciones).
            </p>
          </Section>

          <Section title="6. Destinatarios">
            <p>
              No se cederán datos a terceros salvo por obligación legal. Podrán acceder a los datos, en calidad de
              encargados del tratamiento, los proveedores tecnológicos necesarios para prestar el servicio (alojamiento,
              copias de seguridad, correo), sujetos a las garantías previstas en el RGPD.
            </p>
          </Section>

          <Section title="7. Derechos de los interesados">
            <p>
              Puede ejercitar en cualquier momento sus derechos de acceso, rectificación, supresión, oposición,
              limitación del tratamiento y portabilidad, así como revocar el consentimiento, escribiendo a{" "}
              <a className="text-[#2563EB] hover:underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>{" "}
              e indicando el derecho que desea ejercitar y acompañando copia de un documento identificativo.
              Asimismo, puede presentar una reclamación ante la Agencia Española de Protección de Datos (
              <a className="text-[#2563EB] hover:underline" href="https://www.aepd.es" target="_blank" rel="noreferrer">www.aepd.es</a>
              ).
            </p>
          </Section>

          <Section title="8. Seguridad">
            <p>
              {COMPANY.razon_social} aplica las medidas técnicas y organizativas adecuadas para
              garantizar la confidencialidad, integridad y disponibilidad de los datos personales tratados.
            </p>
          </Section>

          <footer className="pt-4 border-t border-slate-200 text-xs text-slate-500">
            Última actualización: {new Date().toLocaleDateString("es-ES", { year: "numeric", month: "long", day: "numeric" })}
          </footer>
        </article>

        <div className="text-center mt-6 text-xs text-slate-500">
          © {new Date().getFullYear()} {COMPANY.razon_social}. Todos los derechos reservados.
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display font-bold text-lg uppercase tracking-tight text-slate-900 mb-2">{title}</h2>
      <div className="text-sm text-slate-700 space-y-2">{children}</div>
    </section>
  );
}
